import { Row, Col, Form, Well } from 'react-bootstrap';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import TextInput from './TextInput';
import Button from './Button';
import { caseSetServerError } from '../../actions/caseActions';
import { userApiKeyRegister } from './../../actions/userActions';
import { isDemoAccount } from '../../helpers/utils';


class RegisterSubscriptionApiKeyForm extends PureComponent {
    constructor(props) {
        super(props);
        this.registerApiKey = this.registerApiKey.bind(this);
        this.getRegisterButton = this.getRegisterButton.bind(this);
        this.state = { loading: false };
    }

    getRegisterButton() {
        return (
            <Button label="Generate Api Key"
                    icon="link"
                    style={{ marginLeft: 15, marginTop: 10 }}
                    loading={this.props.isSubmitting}
                    disabled={this.state.loading || this.props.isSubmitting || isDemoAccount(this.props.loggedIn)}
                    onClick={this.registerApiKey}
                    tooltip="Get Api key that allows you integrating Case Tempo with 3rd party apps via Zapier."
            />
        );
    }

    registerApiKey() {
        this.setState({ loading: true });
        this.props.dispatch(userApiKeyRegister())
            .then(() => {
                this.setState({ loading: false });
            })
            .catch((error) => {
                console.error(new Error().stack, error);
                this.props.dispatch(caseSetServerError(error));
                this.setState({ loading: false });
            });
    }

    render() {
        const {
            loggedIn,
        } = this.props;

        let output;
        if (loggedIn['SubscriptionApiKey']) {
            output = (
                <Form>
                <TextInput field={{
                                name: 'SubscriptionApiKey',
                                value: loggedIn['SubscriptionApiKey'],
                            }}
                            label="Api Key"
                />
                </Form>
            );
        } else {
            output = (
                <Form>
                {this.getRegisterButton()}
                </Form>
            );
        }

        return output;
    }
}

const mapStateToProps = (state) => {
    return {
        loggedIn: state.user.loggedIn,
    };
};


export default connect(mapStateToProps)(RegisterSubscriptionApiKeyForm);
